import React, { useState } from "react";
import LOGO from "../assets/LOGO.svg";
import Timer from "../components/Timer";
import WalletPopup from "../components/walletpopup";
import ProgressBar from "../components/ProgressBar";
import {Link} from "react-router-dom";
const Howto = ({
  account,
  totalSupply,
  tokenSold,
  loadWeb3,
  startTime,
  endTime,
  days,
  hours,
  minutes,
  seconds,
  difference,
  loadWalleConnect,
  fundsRaised,
}) => {
  const [walletOpen, setWalletOpen] = useState(false);

  const stepsList = [
    {
      title: "STEP1",
      text: "Be sure to have funds on your external/exchange wallet.",
    },
    {
      title: "STEP2",
      text: "Select withdraw/send option to send funds.",
    },
    {
      title: "STEP3",
      text: "Select BEP20 wallet on Binance Smart Chain (BNB chain) network.",
    },
    {
      title: "SEND ASSETS TO THIS WALLET",
      text: "0x40B0d7939e5a43ce7B5022fB5d35c82e9cd3Fdf1",
    },
  ];

  return (
    <div className=" pb-10 px-4">
      <div className=" max-w-6xl mx-auto">
        <div className=" flex justify-between items-center gap-4 py-8">
          <button className="blue-gradient btn px-6 text-xs flex justify-center items-center sm:text-base text-center sm:px-10 py-1.5 font-bold text-white">
            <a href="https://bscscan.com/address/0x8dD0F468A4Dd7ECBd0DD451D6FBfC5a321b13752" target="_blank" rel="noreferrer">
              CONTRACT
            </a>
          </button>
          <img src={LOGO} className="hidden md:block max-w-[250px]" alt="" />
          <button
            className=" orange-gradient btn px-6 text-xs flex justify-center items-center sm:text-base text-center sm:px-10 py-1.5 font-bold text-white"
            onClick={() => setWalletOpen((prev) => !prev)}
          >
            {account
              ? account.slice(0, 8) + "..." + account.slice(account.length - 5)
              : "CONNECT WALLET"}
          </button>
        </div>

        <div className="mt-10 flex justify-center items-center">
          <Link
              to="/"
              className="orange-gradient btn px-6 text-sm flex justify-center items-center sm:text-base text-center sm:px-10 py-1.5 font-bold text-white"
          >
            GO BACK
          </Link>
        </div>

        <div className="mt-20">
          <Timer
            days={days}
            hours={hours}
            minutes={minutes}
            seconds={seconds}
            startTime={startTime}
            endTime={endTime}
            difference={difference}
          />
        </div>
        <div className=" max-w-2xl mx-auto w-full">
          {/*<ProgressBar
            totalSupply={totalSupply}
            fundsRaised={fundsRaised}
            tokenSold={tokenSold}
          />*/}
        </div>
        <div className=" max-w-2xl mx-auto w-full grid gap-y-4 mt-8">
          {stepsList.map((val, i) => (
            <div className=" bg-white bg-opacity-10 p-4 text-center " key={i}>
              <h2 className="font-bold text-2xl mb-2 gradient-text">
                {val.title}
              </h2>
              <p className=" text-white  break-all">{val.text}</p>
            </div>
          ))}
        </div>
        <WalletPopup
          open={walletOpen}
          onClose={setWalletOpen}
          title={account ? "Disconnect Wallet" : "Select a Wallet"}
          text={
            account
              ? "Are you sure you want to disconnect?"
              : "Please select a wallet to connect to this dapp:"
          }
          metaMaskHandler={loadWeb3}
          account={account}
          loadWalleConnect={loadWalleConnect}
        />
      </div>
    </div>
  );
};

export default Howto;
